import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Contents, DropdownMenu, Overlay} from "../../../components";
import {useRecoilState, useRecoilValue} from "recoil";
import {isAdmin, subMenuState} from "../../../../state";
import {SpacingV} from "../../InstructorApp/component/common/Spacing";
import {constCommon} from "../../../../constants";
import {
    AddChapter,
    Col, ContentsHeader,
    FormBox,
    FormBoxItemWrap,
    FormItem,
    Row, SwitchContainer, SwitchInput,
    SwitchItems, SwitchLabel, SwitchSlider
} from "../../../../styled/StyledComponent";
import PlusIcon from "../../../../assets/images/icon/PlusIcon";
import AutoComplete from "../../InstructorApp/component/common/AutoComplete";
import DateIcon from "../../../../assets/images/icon/DateIcon";
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import RemoveGrey from "../../../../assets/images/icon/RemoveGrey";
import {teachersAPI} from "../../../../api/teachersAPI";
import {cloneDeep} from "lodash";
import {isEmpty, textTransform} from "../../../../util";
import dayjs from "dayjs";
import {commonAPI} from "../../../../api/commonAPI";
import CloseIcon from "../../../../assets/images/icon/CloseIcon";
import hashIt from "hash-it";
import EditIcon from "../../../../assets/images/icon/EditIcon";
import {usersAPI} from "../../../../api/usersAPI";
import PurchaseLIst from "./PurchaseList";
import PurchaseList from "./PurchaseList";
import {PiAlignBottom, PiUserSwitchBold} from "react-icons/pi";
import {ImCodepen} from "react-icons/im";
import {FaArrowUpRightDots, FaUser} from "react-icons/fa6";
import {FaBatteryThreeQuarters, FaChartLine} from "react-icons/fa";
import {MdBusiness} from "react-icons/md";
import {FiCoffee} from "react-icons/fi";
import {GrGrow} from "react-icons/gr";
import {RiMoneyCnyBoxLine} from "react-icons/ri";

const eduObj = {
    "degreeType1": "",
    "degreeType2": "",
    "description": "",
    "endedDate": "",
    "schoolName": "",
    "startedDate": "",
};

const expObj = {
    "companyName": "",
    "description": "",
    "endDate": "",
    "position": "",
    "startDate": "",
};

const dataArr = ["aboutTheAuthor", "blogUrl", "name", "profileUrl", "publicJobTitle", "resume"]
const AuthorProfile = (props) => {
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const [info, setInfo] = useState(null);
    const [aboutTheAuthor, setAboutTheAuthor] = useState(null);
    const [blogUrl, setBlogUrl] = useState(null);
    const [instructorName, setInstructorName] = useState("")
    const [profileUrl, setProfileUrl] = useState("")
    const [publicJobTitle, setPublicJobTitle] = useState("")
    const [resume, setResume] = useState(null);
    const [edu, setEdu] = useState([]);
    const [exp, setExp] = useState([]);
    const [skill, setSkill] = useState([]);
    const [jobList, setJobList] = useState([]);
    const [degreeList, setDegreeList] = useState([]);
    const [urlPopup, setUrlPopup] = useState(false)
    const [objList, setObjList] = useState([]);
    const [more, setMore] = useState(false);
    const [warnBtn, setWarnBtn] = useState("");
    const [warnTitle, setWarnTitle] = useState("");
    const [warnPopup, setWarnPopup] = useState(false);
    const [warnType, setWarnType] = useState("ban")
    const getJobList = async () => {
        await commonAPI.getJobList(null).then((res) => {
            console.log("jobList", res);
            const list = cloneDeep(res?.data);
            setJobList(list);
        });
    };
    const getDegreeList = async () => {
        await commonAPI.getDegreeList(null).then((res) => {
            console.log("degreeList", res);
            const list = cloneDeep(res?.data);
            setDegreeList(list);
        });
    };

    const getLearningData = async () => {
        await commonAPI.getLearningObj()
            .then(res => {
                setObjList([...res?.data])
            })
    };

    const putUserStatus = async () => {
        await usersAPI.putUserStatus(props.id,{
            data:{
                banned: false,
                withdraw: false
            }
        })
    }

    const isAdminState = useRecoilValue(isAdmin);
    const getProfile = async () => {
        await usersAPI.getUserById(props.id)
            .then(res => {
                console.log("@userProfile",res);
                setInfo(cloneDeep(res?.data))
            })
    };

    const h = hashIt({
        aboutTheAuthor,
        blogUrl,
        instructorName,
        profileUrl,
        publicJobTitle,
        edu,
        exp,
        skill,
        jobList,
        degreeList
    });

    const patchProfile = async (data = null) => {
        await teachersAPI.patchProfile({
            data:data === null ?  {
                aboutTheAuthor:aboutTheAuthor,
                blogUrl:blogUrl,
                instructorName:instructorName,
                // profileUrl:`www.linkedin.com/in/${profileUrl}`,
                profileUrl:profileUrl,
                publicJobTitle:publicJobTitle,
                resume:{
                    education: cloneDeep(edu),
                    experience: cloneDeep(exp),
                    skillAndCertificates: cloneDeep(skill).filter(item => !isEmpty(item))
                }
            }: cloneDeep(data)
        })
            .then((res) => {
                getProfile()
            })
    }

    console.log("@hash",h);

    const getFormData = (file:any) => {
        const formData = new FormData();
        const thumbnailBlob = new Blob([file], {
            type: file?.type,
        });
        formData.append("file", thumbnailBlob, file?.name);
        return formData;
    };
    const updateProfileImg = async (file:any) => {
        await teachersAPI.postProfileImg({
            data:getFormData(file)
        })
            .then(res => {
                getProfile();
            })
    }

    const returnIcon = (value) => {
        switch (value) {
            case "LEARNING_OBJECTIVE" : {
                return <PiAlignBottom />
            }
            case "ADVANCE_IN_MY_CURRENT_CAREER" : {
                return <ImCodepen/>
            }
            case "BECOME_THE_BEST_VERSION_OF_MYSELF" : {
                return <FaArrowUpRightDots />
            }
            case "SWITCH_TO_A_NEW_CAREER" : {
                return <PiUserSwitchBold />
            }
            case "GAIN_INSPIRATION_OR_MOTIVATION" : {
                return <FaBatteryThreeQuarters />
            }
            case "LAUNCH_A_NEW_BUSINESS" : {
                return <MdBusiness />
            }
            case "ENHANCE_OVERALL_WELL_BEING" : {
                return <FiCoffee />
            }
            case "START_AND_GROW_A_SIDE_HUSTLE" : {
                return <FaChartLine />
            }
            case "ACQUIRE_SKILLS_FOR_PERSONAL_FINANCE" : {
                return <RiMoneyCnyBoxLine />
            }
        }
    }

    const onClickWarnPopup = async () => {
        if(warnType !== "ban"){
            await usersAPI.putUserStatus(props?.id,{
                data:{
                    withdraw:!info?.accessStatusEntity?.withdraw,
                    banned:info?.accessStatusEntity?.banned,
                }
            })
                .then(async res => {
                    await getProfile()
                    await props?.getList()
                    setWarnPopup(false);
                })
        }else{
            await usersAPI.putUserStatus(props?.id,{
                data:{
                    banned:!info?.accessStatusEntity?.banned,
                    withdraw:info?.accessStatusEntity?.withdraw,
                }
            })
                .then(async res => {
                    await getProfile();
                    await props?.getList()
                    setWarnPopup(false);
                })
        }
    }

    const onChangeData = (state, index, property, setState, value) => {
        const c = cloneDeep(state);
        c[index][property] = value;
        setState(cloneDeep(c));
    };

    const itemRef = useRef(null);
    useEffect(() => {
        itemRef.current = patchProfile
        return () => {
            console.log("@h",h);
        }
    }, [h]);

    useLayoutEffect(()=>{
        getProfile();
        getJobList();
        getDegreeList();
        getLearningData();
        return () =>{
            itemRef.current();
        }
    },[]);

    return(
        <Container
            className={isAdminState ? "admin" : ""}
            onSubmit={(e)=>{
                // e.preventDefault();
                // patchProfile();
            }}
        >
            <Contents title={"Whoflex Members"}>
                {
                    warnPopup &&
                    <Overlay filter={false}>
                        <WarnPopup>
                            <ContentsHeader style={{background:"rgba(235, 87, 87, 1)", color:"#fff"}}>
                                {warnTitle}
                            </ContentsHeader>
                            <p>
                                Are you sure to continue?
                            </p>
                            <PopupBtn>
                            <span
                                onClick={()=>{
                                    setWarnPopup(false)
                                }}
                            >
                                Cancel
                            </span>
                            <span
                                onClick={async ()=>{
                                    await onClickWarnPopup()
                                }}
                                style={{background:"#333", color:"#fff"}}>
                                {warnBtn}
                            </span>
                            </PopupBtn>
                        </WarnPopup>
                    </Overlay>
                }
                <ContentsInner>
                    <ProfileHeader>
                        <Thumb>
                            <dt>
                                Profile
                            </dt>
                            <Img>
                                {
                                    info?.profileImage?.url !== null ?
                                    <img src={info?.profileImage?.url} alt=""/> : <FaUser className={"userIcon"} />
                                }
                                <input
                                    onChange={async (e)=>{
                                        await updateProfileImg(e.target.files[0])
                                    }}
                                    type="file"/>
                            </Img>
                        </Thumb>
                        <HeaderContents>
                            <Row display={"flex"} style={{width:"100%"}}>
                                <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                    <FormBox>
                                        <dt>
                                            First Name
                                        </dt>
                                        <dd>
                                            <FormBoxItemWrap>
                                                <li>
                                                    <FormItem>
                                                        <input type="text"
                                                               required={true}
                                                               value={info?.firstName}
                                                               onChange={(e) => {
                                                                   setInstructorName(e.target.value)
                                                               }}
                                                        />
                                                    </FormItem>
                                                </li>
                                            </FormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                                <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                    <FormBox>
                                        <dt>
                                            Last Name
                                        </dt>
                                        <dd>
                                            <FormBoxItemWrap>
                                                <li>
                                                    <FormItem>
                                                        <input
                                                            value={info?.lastName}
                                                            required={true}

                                                            readOnly={true}
                                                            type="text"
                                                        />
                                                        <div
                                                            onClick={()=>{
                                                                setUrlPopup(true)
                                                            }}
                                                            className="editIcon" style={{cursor:"pointer"}}>
                                                        </div>

                                                    </FormItem>
                                                </li>
                                            </FormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                                <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                    <FormBox>
                                        <dt>
                                            Whoflex Name
                                        </dt>
                                        <dd>
                                            <FormBoxItemWrap>
                                                <li>
                                                    <FormItem>
                                                        <input
                                                            required={true}
                                                            value={info?.nickName}
                                                            readOnly={true}
                                                            type="text"
                                                            placeholder={"Whoflex Name"}
                                                        />
                                                        <div
                                                            onClick={()=>{
                                                                setUrlPopup(true)
                                                            }}
                                                            className="editIcon" style={{cursor:"pointer"}}>

                                                        </div>

                                                    </FormItem>
                                                </li>
                                            </FormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                            </Row>
                            <Row display={"flex"} style={{width:"100%"}}>
                                <Col style={{width:"calc((100% - 15px) / 2)"}}>
                                    <FormBox>
                                        <dt>
                                            Email
                                        </dt>
                                        <dd>
                                            <FormBoxItemWrap>
                                                <li>
                                                    <FormItem>
                                                        <input
                                                            required={true}
                                                            value={info?.email}
                                                            readOnly={true}
                                                            type="text"/>
                                                    </FormItem>
                                                </li>
                                            </FormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                                <Col style={{width:"calc((100% - 15px) / 2)"}}>
                                    <FormBox>
                                        <dt>
                                            Password
                                        </dt>
                                        <dd>
                                            <FormBoxItemWrap>
                                                <li>
                                                    <FormItem>
                                                        <input
                                                            // required={true}
                                                            // value={publicJobTitle}
                                                            readOnly={true}
                                                            onChange={(e) => {
                                                                setPublicJobTitle(e.target.value)
                                                            }}
                                                            placeholder={"Password"}
                                                            type="password" />
                                                    </FormItem>
                                                </li>
                                            </FormBoxItemWrap>
                                        </dd>
                                    </FormBox>
                                </Col>
                            </Row>
                        </HeaderContents>
                    </ProfileHeader>
                    <ContentBox>
                        <Row display={"flex"} style={{width:"100%"}}>
                            <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                <FormBox>
                                    <dt>
                                        Country
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input type="text"
                                                           required={true}
                                                           value={info?.accessInfo?.country}
                                                           onChange={(e) => {
                                                               setInstructorName(e.target.value)
                                                           }}
                                                           placeholder={"Country"}
                                                           />
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                            <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                <FormBox>
                                    <dt>
                                      City
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input
                                                        required={true}
                                                        placeholder={"City"}
                                                        onChange={(e) => {
                                                            setProfileUrl(e.target.value)
                                                        }}
                                                        value={info?.accessInfo?.city}
                                                        readOnly={true}
                                                        type="text"/>
                                                    <div
                                                        onClick={()=>{
                                                            setUrlPopup(true)
                                                        }}
                                                        className="editIcon" style={{cursor:"pointer"}}>

                                                    </div>

                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                            <Col style={{width:"calc((100% - 30px) / 3)"}}>
                                <FormBox>
                                    <dt>
                                       Zip Code
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input
                                                        required={true}
                                                        placeholder={"Zip Code"}
                                                        value={info?.accessInfo?.code}
                                                        onChange={(e) => {
                                                            setProfileUrl(e.target.value)
                                                        }}
                                                        readOnly={true}
                                                        type="text" />
                                                    <div
                                                        onClick={()=>{
                                                            setUrlPopup(true)
                                                        }}
                                                        className="editIcon" style={{cursor:"pointer"}}>

                                                    </div>

                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>
                        <Row display={"flex"} style={{width:"100%"}}>
                            <Col>
                                <FormBox>
                                    <dt>
                                        Registration Date
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input
                                                        value={info?.createdDatetime}
                                                        required={true}
                                                        readOnly={true}
                                                        type="text"/>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                            <Col  >
                                <FormBox>
                                    <dt>
                                        Last Access Date
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input
                                                        value={info?.accessInfo?.datetime}
                                                        required={true}
                                                        readOnly={true}
                                                        type="text"/>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>
                        <Row display={"flex"} style={{width:"100%"}}>
                            <Col>
                                <FormBox>
                                    <dt>
                                        Withdrawal Date
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input
                                                        required={true}
                                                        value={info?.accessStatusEntity?.withdrawDatetime === null ? "" : info?.accessStatusEntity?.withdrawDatetime}
                                                        readOnly={true}
                                                        type="text"/>
                                                    <div
                                                        onClick={()=>{
                                                            // setUrlPopup(true)
                                                        }}
                                                        className="editIcon" style={{cursor:"pointer"}}>

                                                        <SwitchItems style={{paddingRight:10}}>
                                                            {/*<span>*/}
                                                            {/*    {textTransform()?.capitalizeFirstLetter(String(item?.type)?.toLocaleLowerCase())}*/}
                                                            {/*</span>*/}
                                                            <SwitchContainer>
                                                                <SwitchLabel isOn={info?.accessStatusEntity?.withdraw}>
                                                                    <SwitchInput type="checkbox" checked={info?.accessStatusEntity?.withdraw} onChange={async () => {
                                                                        setWarnType("withdraw")
                                                                        setWarnPopup(true);
                                                                        setWarnTitle("User withdrawal status update");
                                                                        setWarnBtn(info?.accessStatusEntity?.withdraw ? "Restore User" : "Withdrawal")

                                                                    }} />
                                                                    <SwitchSlider isOn={info?.accessStatusEntity?.withdraw} />
                                                                </SwitchLabel>
                                                            </SwitchContainer>
                                                        </SwitchItems>
                                                    </div>

                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                            <Col  >
                                <FormBox>
                                    <dt>
                                        Access Blocking Date
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <input
                                                        required={true}
                                                        value={info?.accessStatusEntity?.banDatetime === null ? "" : info?.accessStatusEntity?.banDatetime}
                                                        readOnly={true}
                                                        type="text" />
                                                        <div
                                                            onClick={()=>{
                                                                // setUrlPopup(true)
                                                            }}
                                                            className="editIcon" style={{cursor:"pointer"}}>
                                                            {/*<EditIcon/>*/}

                                                            <SwitchItems style={{paddingRight:10}}>
                                                                {/*<span>*/}
                                                                {/*    {textTransform()?.capitalizeFirstLetter(String(item?.type)?.toLocaleLowerCase())}*/}
                                                                {/*</span>*/}
                                                                <SwitchContainer >
                                                                    <SwitchLabel isOn={info?.accessStatusEntity?.banned} >
                                                                        <SwitchInput type="checkbox" checked={info?.accessStatusEntity?.banned} onChange={async () => {
                                                                            setWarnType("ban")
                                                                            setWarnPopup(true);
                                                                            setWarnTitle("Change User Blocking Status");
                                                                            setWarnBtn(info?.accessStatusEntity?.banned ? "Restore User" : "Block User")
                                                                        }} />
                                                                        <SwitchSlider isOn={info?.accessStatusEntity?.banned} />
                                                                    </SwitchLabel>
                                                                </SwitchContainer>
                                                            </SwitchItems>
                                                        </div>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>
                    </ContentBox>
                </ContentsInner>
            </Contents>
            <SpacingV height={30} />
            <Contents title={"Goals & Objectives"}>
                <ContentsInner>

                    <ContentBox>

                        <Objective>

                            <Career>
                                <h2>
                                    Career Goals
                                </h2>
                                <Row display={"flex"} style={{width: "100%"}}>
                                    <Col style={{width: "100%"}}>
                                        <FormBox>
                                            <dt>
                                                I am currently an
                                            </dt>
                                            <dd>
                                                <FormBoxItemWrap>
                                                    <li>
                                                        <AutoComplete
                                                            options={cloneDeep(jobList)}
                                                            placeholder={"Enter your profession"}
                                                            value={info?.careerGoal?.current}
                                                            required={false}
                                                            formType={true}
                                                            onChange={(value) => {
                                                                // onChangeData(edu,index,"degreeType1", setEdu, value)
                                                            }}
                                                        />
                                                    </li>
                                                </FormBoxItemWrap>
                                            </dd>
                                        </FormBox>
                                    </Col>
                                </Row>
                                <Row display={"flex"} style={{width: "100%"}}>
                                    <Col style={{width: "100%"}}>
                                        <FormBox>
                                            <dt>
                                                I want to be a
                                            </dt>
                                            <dd>
                                                <FormBoxItemWrap>
                                                    <li>
                                                        <AutoComplete
                                                            options={cloneDeep(jobList)}
                                                            placeholder={"Enter your desire job"}
                                                            value={info?.careerGoal?.tobe}
                                                            required={false}
                                                            formType={true}
                                                            onChange={(value) => {
                                                                // onChangeData(edu,index,"degreeType1", setEdu, value)
                                                            }}
                                                        />
                                                    </li>
                                                </FormBoxItemWrap>
                                            </dd>
                                        </FormBox>
                                    </Col>
                                </Row>
                            </Career>
                            <Learning>
                                <h2>
                                Learning Objectives
                                </h2>
                                <Objs className={more ? "moreMenu" : ""}
                                    style={{
                                        height:more ? 39 * objList?.length + 20 : 215
                                    }}
                                >
                                    {
                                        objList?.map(item => {
                                            return (
                                                <ObjItem>
                                                  <span
                                                      className={info?.learningObjective === item ? "on" : ""}
                                                  ><b>{returnIcon(item)}</b> {item.replaceAll("_", " ")}</span>
                                                </ObjItem>
                                            )
                                        })
                                    }
                                    <div className={`more ${more ? "moreMenu" : ""}`} onClick={()=>{setMore(v => !v)}}>
                                        <svg width="18" height="9" viewBox="0 0 18 9" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M16.9201 0.949219L10.4001 7.46922C9.63008 8.23922 8.37008 8.23922 7.60008 7.46922L1.08008 0.949219"
                                                stroke="#666666" strokeWidth={"1.5"} strokeMiterlimit={"10"}
                                                strokeLinecap={"round"} strokeLinejoin={"round"}/>
                                        </svg>
                                        <span>
                                            Show more
                                        </span>
                                    </div>


                                </Objs>
                            </Learning>
                        </Objective>
                    </ContentBox>

                </ContentsInner>
                {/*<ContentBox*/}
                {/*    style={{*/}
                {/*        justifyContent:"flex-end",*/}
                {/*        display:"flex"*/}
                {/*    }}>*/}
                {/*    <AddChapter*/}
                {/*        style={{marginRight:10}}*/}
                {/*        onClick={() => {*/}
                {/*            patchProfile();*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <button*/}
                {/*            type={"submit"}*/}
                {/*            style={{marginRight:0}}>Save</button>*/}
                {/*    </AddChapter>*/}
                {/*    <AddChapter*/}

                {/*        onClick={() => {*/}
                {/*            patchProfile();*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <button*/}
                {/*            type={"submit"}*/}
                {/*            style={{marginRight:0}}>Publish</button>*/}
                {/*    </AddChapter>*/}
                {/*</ContentBox>*/}
            </Contents>
            <SpacingV height={30} />
            <Contents title={"Purchase History"}>
                    <PurchaseList/>
            </Contents>
        </Container>
    )

}
export default AuthorProfile;

const Container = styled.form`
    .overlay{
        background: none;
    }
    &.admin{
        .commonContents{
            box-shadow: none!important;
        }
        .commonContentsHeader{
            background: #fff;
            border-bottom: solid 1px #ddd;
        }
    }
`;
const WarnPopup = styled.div`
   background: rgba(255, 255, 255, 1);
    width: 380px;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    box-shadow: -1px 1px 4px 0px #3333331F;
    
    p{
        font-family: Europa-Regular;
        font-size: 20px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 35px;
        margin-top: 35px;
        text-align: center;
    }
`
const PopupBtn = styled.div`
   display: flex;
   align-items: center;
    justify-content: center;
    
   span{
       display: flex;
       cursor: pointer;
       width: 120px;
       height: 45px;
       border-radius: 4px;
       border: solid 1px #111;
       align-items: center;
       justify-content: center;
       margin: 0 10px;
   }
`
const ContentsInner = styled.div`
   padding: 20px 0px;
   h1{
       font-family: Europa-Bold;
       font-size: 18px;
       font-weight: 700;
       line-height: 24px;
       letter-spacing: 0em;
       text-align: left;
       color: #DDC160;
   } 
    h2{
        font-family: Europa-Bold;
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 20px;
    }
`
const ProfileHeader = styled.div`
   display: flex;
   padding: 0 20px;
   width: 100%;
   input{
       width: 100%;
   }
`
const ContentBox = styled.div`
   padding: 0 20px;
`
const Thumb = styled.div`
    margin-right: 18px;
    > dt {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        opacity: 0.8;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`
const Img = styled.div`
   width: 138px;
   height: 138px;
   background: #eee;
   border-radius: 8px;
   position: relative;
   cursor: pointer;
   overflow: hidden;
    .userIcon{
        padding: 10px;
        width: 100%;
        height: 100%;
        color: #ddd;
    }
   img{
       width: 100%;
       height: 100%;
       object-fit: cover;
   }
   input{
       cursor: pointer;
       width: 100%;
       height: 100%;
       position: absolute;
       opacity: 0;
       z-index: 9;
   }
`
const HeaderContents = styled.div`
   width: 100%;
`
const Objective = styled.div`
   display: flex;
    align-items: flex-start;
    justify-content: space-between;
`
const Career = styled.div`
   width: 60%;
`
const Learning = styled.div`
    transition: all 0.25s;
   
`
const Objs = styled.div`
    transition: all 0.25s;
    overflow-y: hidden;
    padding-bottom: 25px;
    position: relative;
    height: 215px;
    
    .more{
        background: #fff;
        width: 100%;
        bottom: 0;
        left: 0;
        position: absolute;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.moreMenu{
            left: 50%;
            width: 50%;
            span{
                display: none;
            }
            svg{
                transform: rotate(180deg);
            }
        
        }
        span{
            margin-left: 10px;
            /* Show more */

            /* Show more */

            width: 102px;
            height: 28px;

            font-family: 'Arial';
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height, or 140% */
            display: flex;
            align-items: center;
            text-align: right;

            color: #666666;


            /* Inside auto layout */
            flex: none;
            order: 1;
            flex-grow: 0;
        }
    }
`
const ObjItem = styled.div`
    font-family: Europa-Regular;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 15px;
    cursor: pointer;
    span{
        &.on{
            svg{

                color:rgba(221, 193, 96, 1);;
            }
            color:rgba(221, 193, 96, 1);;
        }
        display: flex;
        align-items: center;
        b{
            display: flex;
            align-items: center;
            line-height: 1;
            margin-right: 10px;
        }
    }
`
const Experience = styled.div`

`
const ExperienceItem = styled.div`
    padding-top: 20px;
    position: relative;
    &.border {
        border-top: 1px solid transparent;
        padding-top: 45px;
        border-image: url("/images/line.png") 10 repeat;
    }
    padding-bottom: 10px;
    
`
const RemoveItem = styled.div`
   width: 51px;
   background: #333; 
   height: 25px;
   position: absolute; 
   right: 0;
   top: 0;
   display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`
const Skills = styled.div`
   border-top:solid 0.6px #3333334D;
   padding-top: 30px;
   padding-bottom: 20px;  
`
const SkillsItem = styled.div`
   
`
const Edu = styled.div`
    padding-top: 30px;
    padding-bottom: 20px;
    border-top:solid 0.6px #3333334D;
`
const EduItem = styled.div`
    position: relative;
    &.border {
        border-top: 1px solid transparent;
        padding-top: 45px;
        border-image: url("/images/line.png") 10 repeat;
    }
    padding-bottom: 10px;
`

const StyledDateInput = styled(FormItem)`
  position: relative;
 
`;

const PlItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    position: absolute;
    width: calc(100% - 5px);
    content: "abc";
    left: 50%;
    top: 51%;
    transform: translate(-50%, -50%);
    color: rgba(51, 51, 51, 0.20);
    &.on{
        color: #333;
    }
    input{
        padding: 0;
        border: none;
        font-family: Europa-Regular;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0em;
        text-align: left;
        border-radius: 8px;
        padding: 12px 0px;
        height: calc(100% - 5px);
        pointer-events: none;
        &::placeholder {
            color: #ddd;
        }
    }
    font-family: Europa-Regular;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    border-radius: 8px;
    padding: 12px 16px;
    height: calc(100% - 5px);
    pointer-events: none;
`